import { render, staticRenderFns } from "./UltimateTransactions.vue?vue&type=template&id=ee2e0e60&"
import script from "./UltimateTransactions.vue?vue&type=script&lang=js&"
export * from "./UltimateTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports